var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("nav",null,{"nav":{ count: _vm.count, currentFocused: _vm.currentFocused, prev: _vm.prev, next: _vm.next, replace: _vm.replace }}),_c('div',{ref:"doc"},[_vm._t("content")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }